import React, { memo } from "react";
import s from "./style.module.scss";
import Button from "shared/ui/Button";
import { INewsItem } from "../api/models";
import ImageLazy from "shared/ui/ImageLazy";
import { Link, useNavigate } from "react-router-dom";

const Item: React.FC<INewsItem> = memo(({ url, image, title, id }) => {
  const navigate = useNavigate();

  return (
    <div className={s.item}>
      <Link to={`/news/${id}`} />

      <div className={s.image}>
        <ImageLazy src={image} alt="Image" />
      </div>

      <div className={s.content}>
        <h3>{title}</h3>

        <Button onClick={() => navigate(`/news/${id}`)} white>
          Подробнее
        </Button>
      </div>
    </div>
  );
});

export default Item;
